webpackJsonp([10483611427234],{

/***/ 2139:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"Bill","kind":"UNION","type":"OBJECT","fields":null,"description":"A bill is a pending order, posted invoice, or published estimate","enumValues":null,"possibleTypes":[{"kind":"OBJECT","name":"Estimate","ofType":null},{"kind":"OBJECT","name":"Order","ofType":null}]}}

/***/ })

});


// WEBPACK FOOTER //
// path---union-bill-16ed778e7e2ff6833e0b.js